import { ReactElement } from 'react';
import { useCatalogFacetFiltersActions, useSearchData } from '@client/catalog/hooks';
import { CatalogFilters } from './CatalogFilters';
import { Props } from './CatalogFiltersContainer.types';

export const CatalogFiltersContainer = ({
  isLevelZeroAvailable = false,
  availableFacetFilters,
  onFilterChange,
}: Props): ReactElement => {
  const { data } = useSearchData();
  const {
    handleCategoryChange,
    handleFacetFilterCheckboxChange,
    handleFacetFilterRangeChange,
  } = useCatalogFacetFiltersActions(onFilterChange);

  return (
    <CatalogFilters
      categories={data.navigation}
      isLevelZeroAvailable={isLevelZeroAvailable}
      availableFacetFilters={availableFacetFilters}
      onCategoryChange={handleCategoryChange}
      onFacetFilterCheckboxChange={handleFacetFilterCheckboxChange}
      onFacetFilterRangeChange={handleFacetFilterRangeChange}
    />
  );
};
